import HwkTemplateSelector from './src/main';

/* istanbul ignore next */
HwkTemplateSelector.install = function(Vue) {
  Vue.component(HwkTemplateSelector.name, HwkTemplateSelector);
};

export default HwkTemplateSelector;
